package api

import kotlinx.serialization.Serializable

@Serializable
data class Token(val braintreeToken: String)